import React from "react";
import AppBar from "@material-ui/core/AppBar";
import { Typography } from "@material-ui/core";
import Toolbar from "@material-ui/core/Toolbar";
import "./Footer.css";
import Grid from "@material-ui/core/Grid";

const Footer = props => (
  <Grid item xs={12}>
    <div className="Footer">
      <div className="GridFooter">
        <div className="FooterCompImg">
          <img src="./img/img-home.png" className="FooterImg" />
        </div>
        <div className="FooterComp">
          <div className="FooterTitle">Administración y Ventas:</div>
          <div className="FooterText">
            Llavallol 3331, CABA
            <br />
            4505-8632 <br />
            servicioposventa@prana.com.ar
            <br /> Lun a Vie 8.00 a 13hs y 14 a 18hs
          </div>
        </div>

        <div className="FooterCompImg">
          <img src="./img/img-logo.png" className="FooterImg" />
        </div>
        <div className="FooterComp">
          <div className="FooterTitle">Servicio Toyota:</div>
          <div className="FooterText">
            Llavallol 3331, CABA
            <br />
            4505-8632 <br />
            servicioposventa@prana.com.ar
            <br /> Lun a Vie 8.00 a 13hs y 14 a 18hs
          </div>
        </div>
      </div>
    </div>
  </Grid>
); //<AppBar color="secondary" style={styles.footer} />;

export default Footer;
